import { render, staticRenderFns } from "./UserChatInfo.vue?vue&type=template&id=5265d94d&scoped=true"
import script from "./UserChatInfo.vue?vue&type=script&lang=js"
export * from "./UserChatInfo.vue?vue&type=script&lang=js"
import style0 from "./UserChatInfo.vue?vue&type=style&index=0&id=5265d94d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5265d94d",
  null
  
)

export default component.exports